@if (showBanner && inlineAlertBanner) {
<div class="-inline-alert-banner-container">
  <div class="-center-group">
    <span class="-message">
      {{ inlineAlertBanner?.message }}<span class="-spacer"> </span
      ><app-link
        class="-cta"
        [to]="inlineAlertBanner?.cta?.[0]?.path"
        >{{ inlineAlertBanner?.cta?.[0]?.title }}</app-link
      >
    </span>
  </div>
  <button class="-close" (click)="closeBanner()" type="button" aria-label="Close">
    <lucide-icon name="x" size="24"></lucide-icon>
  </button>
</div>
}
